import React from 'react';
import { motion, Variants } from 'framer-motion';

const draw: Variants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: (i: number) => ({
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { delay: i * 0.2, type: "spring" as const, duration: 1.5, bounce: 0 },
      opacity: { delay: i * 0.2, duration: 0.01 }
    }
  })
};

const AnimatedLogo = () => {
  return (
    <motion.svg
      width="800"
      height="200"
      viewBox="0 0 300 100"
      initial="hidden"
      animate="visible"
      className="max-w-full mx-auto"
    >
      {/* C */}
      <motion.path
        d="M 49 74 C 25 75 15 65 15 50 C 15 35 25 25 42 24 C 44 24 47 24 50 25"
        stroke="#333333"
        variants={draw}
        custom={0}
        style={{
          strokeWidth: 8,
          strokeLinecap: "round",
          fill: "transparent"
        }}
      />
      
      {/* t */}
      <motion.path
        d="M80 20L80 70M65 20L95 20"
        stroke="#333333"
        variants={draw}
        custom={1}
        style={{
          strokeWidth: 8,
          strokeLinecap: "round",
          fill: "transparent"
        }}
      />
      
      {/* r */}
      <motion.path
        d="M110 40L110 70M110 45C110 40 115 35 125 35"
        stroke="#333333"
        variants={draw}
        custom={2}
        style={{
          strokeWidth: 8,
          strokeLinecap: "round",
          fill: "transparent"
        }}
      />
      
      {/* l */}
      <motion.path
        d="M140 20L140 70"
        stroke="#333333"
        variants={draw}
        custom={3}
        style={{
          strokeWidth: 8,
          strokeLinecap: "round",
          fill: "transparent"
        }}
      />

      {/* C */}
      <motion.path
        d="M 199 74 C 175 75 165 65 165 50 C 165 35 175 25 192 24 C 194 24 197 24 200 25"
        stroke="#407CBD"
        variants={draw}
        custom={4}
        style={{
          strokeWidth: 8,
          strokeLinecap: "round",
          fill: "transparent"
        }}
      />
      
      {/* V */}
      <motion.path
        d="M 220 25 L 243 73 Q 245 78 247 73 L 270 25"
        stroke="#407CBD"
        variants={draw}
        custom={5}
        style={{
          strokeWidth: 8,
          strokeLinecap: "round",
          fill: "transparent"
        }}
      />

      {/* Dot */}
      <motion.circle
        cx="290"
        cy="15"
        r="8"
        fill="#407CBD"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.5, duration: 0.3, type: "spring" as const }}
      />
    </motion.svg>
  );
};

export default AnimatedLogo;
